import { NgModule, InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

export let APP_CONFIG = new InjectionToken<AppConfig>(('app.config'));

class ApiConfig {
    core: { endpoint: string };
}

class Dibs {
    merchant: string;
    callbackUrl: string;
}

class Nets {
    merchantId: string;
    terminalUrl: string;
}

export class AppConfig {
    production: boolean;
    api: ApiConfig;
    dibs: Dibs;
    nets: Nets;
}

export const API_DI_CONFIG: AppConfig = {
    production: environment.production,
    api: environment.api,
    dibs: environment.dibs,
    nets: environment.nets
};

@NgModule({
    providers: [{ provide: AppConfig, useValue: API_DI_CONFIG }]
})
export class AppConfigModule { }
